import React, { useEffect } from "react";
import { dashboardBannerAPI } from "../service/AuthService";
import Rules from "./Rules";

export default function InitialRule() {
  const [show, setShow] = React.useState(true);
  const [banners, setBanners] = React.useState([]);

  const getBanner = async () => {
    const { response } = await dashboardBannerAPI();
    if (response) {
      setBanners(
        response?.sort((a, b) => a?.bannerPriority - b?.bannerPriority)
      );
    }
  };
  const showRules = true;
  const textBasedRule = true;
  useEffect(() => {
    getBanner();
  }, []);
  if (localStorage.getItem("initialRule") != "true") {
    return (
      <Rules
        show={localStorage.getItem("initialRule") != "true"}
        setIsRuleExpanded={() => {
          localStorage.setItem("initialRule", "true");
          setShow(false);
        }}
      />
    );
  }
}
        
